import React from 'react';
import './NotFound.css'

const NotFound = () => {
    return (
        <div className="notfound-section h-screen">
            <div className="flex justify-center ">
                <a className="btn btn-info btn-lg fw-bold mt-[550px]" href="/">Go to Home</a>
            </div>
        </div>
    );
};

export default NotFound;